export default {
  twoFactor: {
    // TwoFactorCard
    title: "Two-factor authentication (2FA)",
    loading: "Loading…",
    error: "Error",
    enabledBadge: "✓ Enabled.",
    enabledDesc: "Your account requires a code from your authenticator app when you sign in.",
    orgRequires: " Your organization requires 2FA, so it can't be disabled.",
    disable: "Disable 2FA",
    currentPwdPlaceholder: "Your current password",
    cancel: "Cancel",
    confirmDisable: "Confirm deactivation",
    disabledDesc: "Add an extra layer of security: on top of your password, it will ask for a temporary code from your phone when you sign in.",
    enable: "Enable 2FA",
    // TwoFactorSetup
    setupError: "Couldn't start setup",
    wrongCode: "Incorrect code",
    preparing: "Preparing…",
    activatedTitle: "✅ 2FA enabled",
    backupPre: "Save these ",
    backupTerm: "backup codes",
    backupPost: " in a safe place. Each one works only once if you lose access to your authenticator app. They won't be shown again.",
    backupSaved: "I've saved my codes — continue",
    scanInstructions: "Scan this QR code with Google Authenticator, Authy or 1Password, and enter the 6-digit code.",
    qrAlt: "2FA QR code",
    manualKeyPrompt: "Can't scan? Manual key:",
    codePlaceholder: "6-digit code",
    verifying: "Verifying…",
  },
};
